'use client';

import { ChevronLeft, ChevronRight } from 'lucide-react';

import Button from '@/src/components/UI/Button';

interface PaginationProps {
  page: number;
  pageCount: number;
  start: number;
  end: number;
  total: number;
  onPrevious: () => void;
  onNext: () => void;
}

const Pagination: React.FC<PaginationProps> = ({
  page,
  pageCount,
  start,
  end,
  total,
  onPrevious,
  onNext,
}) => (
  <nav
    aria-label="Meeting pages"
    className="flex items-center justify-between gap-4 pt-4 mt-4 border-t-2 border-black"
  >
    <Button
      ariaLabel="Previous page of meetings"
      disabled={page <= 0}
      icon={ChevronLeft}
      onClick={onPrevious}
      title="Previous"
    />
    <p aria-live="polite" className="text-sm text-center">
      {start}–{end} of {total}
    </p>
    <Button
      ariaLabel="Next page of meetings"
      disabled={page >= pageCount - 1}
      icon={ChevronRight}
      onClick={onNext}
      title="Next"
    />
  </nav>
);

export default Pagination;
